
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire8a08"];
var parcelRegister = parcelRequire.register;
parcelRegister("l44HZ", function(module, exports) {

$parcel$export(module.exports, "ConnectionErrorModal", function () { return $f55d9fb6f46faeb8$export$d5efa285eaf49161; });

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $jCoLF = parcelRequire("jCoLF");

var $hUmGa = parcelRequire("hUmGa");

var $7opAt = parcelRequire("7opAt");

var $6m3m5 = parcelRequire("6m3m5");

var $f77a8 = parcelRequire("f77a8");

var $e4GVY = parcelRequire("e4GVY");

var $jd4Uk = parcelRequire("jd4Uk");

var $igCUb = parcelRequire("igCUb");

var $cYFxl = parcelRequire("cYFxl");
const $f55d9fb6f46faeb8$var$Container = (0, $jCoLF.default).div.withConfig({
    displayName: "ConnectionErrorModal__Container",
    componentId: "sc-1b1hbru-0"
})([
    "display:flex;flex-direction:column;align-items:center;max-width:653px;width:100%;padding:50px;box-sizing:border-box;@media (max-width:768px){padding:40px;}"
]);
const $f55d9fb6f46faeb8$var$TextContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "ConnectionErrorModal__TextContainer",
    componentId: "sc-1b1hbru-1"
})([
    "display:flex;flex-direction:column;align-items:center;text-align:center;gap:10px;"
]);
const $f55d9fb6f46faeb8$var$HeadingContainer = (0, $jCoLF.default).div.withConfig({
    displayName: "ConnectionErrorModal__HeadingContainer",
    componentId: "sc-1b1hbru-2"
})([
    "max-width:450px;margin:0 auto;margin-bottom:20px;text-align:center;"
]);
const $f55d9fb6f46faeb8$var$WarningImage = (0, $jCoLF.default).img.withConfig({
    displayName: "ConnectionErrorModal__WarningImage",
    componentId: "sc-1b1hbru-3"
})([
    "max-height:120px;margin-bottom:32px;"
]);
const $f55d9fb6f46faeb8$var$getImageBase64 = async (imageURL)=>{
    return (0, $f77a8.getBase64)(await fetch(imageURL).then((response)=>response.blob()));
};
const $f55d9fb6f46faeb8$export$d5efa285eaf49161 = (0, $hUmGa.observer)((props)=>{
    const { isShown: isShown } = props;
    const [loadedImages, setLoadedImages] = (0, $bh6RR.useState)({
        warningImage: (0, (/*@__PURE__*/$parcel$interopDefault($e4GVY))),
        loaderIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jd4Uk)))
    });
    (0, $bh6RR.useEffect)(()=>{
        Object.entries(loadedImages).forEach(async ([key, url])=>{
            // Если обрубится соединение, мы не сможем получить изображения по URL
            const imageBase64 = await $f55d9fb6f46faeb8$var$getImageBase64(url);
            setLoadedImages((state)=>({
                    ...state,
                    [key]: imageBase64
                }));
        });
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7opAt.default), {
            open: isShown,
            children: /*#__PURE__*/ (0, $ih19M.jsxs)($f55d9fb6f46faeb8$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($f55d9fb6f46faeb8$var$WarningImage, {
                        src: loadedImages.warningImage,
                        alt: "Warning"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($f55d9fb6f46faeb8$var$HeadingContainer, {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6m3m5.HeadingH4), {
                            children: "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B \u0441 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C"
                        })
                    }),
                    !(0, $igCUb.default).isAsyaAvailable && (0, $igCUb.default).isOuterServiceAvailable && /*#__PURE__*/ (0, $ih19M.jsxs)($f55d9fb6f46faeb8$var$TextContainer, {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6m3m5.PXSmall), {
                                modifiers: [
                                    "gray"
                                ],
                                children: "\u0410\u0441\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430, \u043D\u0435\u0442 \u0441\u0435\u0442\u0435\u0432\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0441\u0435\u0440\u0432\u0435\u0440\u0443 \u0410\u0441\u0438."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6m3m5.PXSmall), {
                                modifiers: [
                                    "gray"
                                ],
                                children: "\u041D\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u043A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u0442\u0435\u0432\u043E\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0441\u044F \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cYFxl.BlockLoader), {})
                        ]
                    }),
                    !(0, $igCUb.default).isAsyaAvailable && !(0, $igCUb.default).isOuterServiceAvailable && /*#__PURE__*/ (0, $ih19M.jsxs)($f55d9fb6f46faeb8$var$TextContainer, {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6m3m5.PXSmall), {
                                modifiers: [
                                    "gray"
                                ],
                                children: "\u0410\u0441\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0441 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043E\u043C."
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $6m3m5.PXSmall), {
                                modifiers: [
                                    "gray"
                                ],
                                children: "\u041D\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443, \u043A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0441\u044F \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $cYFxl.BlockLoader), {})
                        ]
                    })
                ]
            })
        })
    });
});

});
parcelRegister("e4GVY", function(module, exports) {
module.exports = new URL("warning.2f61946c.png", import.meta.url).toString();

});

parcelRegister("jd4Uk", function(module, exports) {
module.exports = new URL("loader.24d4c9b9.svg", import.meta.url).toString();

});



//# sourceMappingURL=ConnectionErrorModal.ce28cec6.js.map
